/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps*/
import React, { useEffect } from "react";
import { Button, Row, Col, DatePicker, Form, Input, Select } from "antd";
import { useTranslate } from "../../../Translate";
const { Search } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
};

const TwoColProps = {
  ...ColProps,
  xl: 96,
};

const Filter = ({ onFilterChange, groups, optionTypeSelected, type }) => {
  const i18n = useTranslate();
  const { t } = i18n;
  const formRef = React.createRef();
  /*eventuale normalizzazione dei dati tipo la data*/
  const handleFields = (fields) => {
    return fields;
  };
  const handleSubmit = () => {
    const values = formRef.current.getFieldsValue();
    const fields = handleFields(values);
    onFilterChange(fields);
  };
  /*funzione per il reset del form*/
  const handleReset = () => {
    //ottengo tutti i campi del form con i rispettivi valori
    const fields = formRef.current.getFieldsValue();
    for (let item in fields) {
      if ({}.hasOwnProperty.call(fields, item)) {
        if (fields[item] instanceof Array) {
          fields[item] = [];
        } else {
          fields[item] = undefined;
        }
      }
    }
    formRef.current.setFieldsValue(fields);
    onFilterChange([]);
  };

  const onChangeType = (value) => {
    formRef.current.setFieldsValue({type: value})
  };

  const onSearch = (value) => {
    console.log("search:", value);
  };

  useEffect(() => {
    formRef.current.setFieldsValue({
      type: optionTypeSelected ? optionTypeSelected.toString() : undefined,
    });
  }, [optionTypeSelected]);

  return (
    <Form
      ref={formRef}
      name="control-ref"
      initialValues={{
        type: "2",
      }}
    >
      <Row gutter={24}>
        <Col {...ColProps} xl={{ span: 6 }} md={{ span: 6 }} id="lkgroups">
          <Form.Item name="groups">
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder={t("selectgroup")}
              optionFilterProp="children"
              filterOption={(input, option) => option.children.includes(input)}
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {groups}
            </Select>
          </Form.Item>
        </Col>
        <Col {...ColProps} xl={{ span: 4 }} md={{ span: 6 }} id="lyType">
          <Form.Item name="type" >
            {type === undefined ? (
              <Select
                style={{ width: "100%" }}
                showSearch
                onChange={onChangeType}
                placeholder={t("selecttype")}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.includes(input)
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {optionTypeSelected === 2 ? (
                  <>
                    <Option value="0" key="0" disabled={true}>
                      {t("initialization")}
                    </Option>
                    <Option value="1" disabled={true} key="1">
                      {t("accredit")}
                    </Option>
                    <Option value="2" key="2">
                      {t("charge")}
                    </Option>
                    <Option value="3" disabled={true} key="3">
                      {t("transfer2")}
                    </Option>
                  </>
                ) : optionTypeSelected === 1 ? (
                  <>
                    <Option value="0" key="0" disabled={true}>
                      {t("initialization")}
                    </Option>
                    <Option value="1" key="1">
                      {t("accredit")}
                    </Option>
                    <Option value="2" disabled={true} key="2">
                      {t("charge")}
                    </Option>
                    <Option value="3" disabled={true} key="3">
                      {t("transfer2")}
                    </Option>
                  </>
                ) : (
                  <>
                    <Option value="0" key="0">
                      {t("initialization")}
                    </Option>
                    <Option value="1" key="1">
                      {t("accredit")}
                    </Option>
                    <Option value="2" key="2">
                      {t("charge")}
                    </Option>
                    <Option value="3" key="3">
                      {t("transfer2")}
                    </Option>
                  </>
                )}
              </Select>
            ) : (
              <>
                <Select
                  style={{ width: "100%" }}
                  showSearch
                  onChange={onChangeType}
                  placeholder={t("selecttype")}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  <Option value="0" key="0">
                    {t("initialization")}
                  </Option>
                  <Option value="1" key="1">
                    {t("accredit")}
                  </Option>
                  <Option value="2" key="2">
                    {t("charge")}
                  </Option>
                  <Option value="3" key="3">
                    {t("transfer2")}
                  </Option>
                </Select>
              </>
            )}
          </Form.Item>
        </Col>
        <Col
          {...ColProps}
          xl={{ span: 8 }}
          md={{ span: 10 }}
          sm={{ span: 12 }}
          id="dataInserimento"
          style={{ border: "0px solid" }}
        >
          <Form.Item
            //initialValue={moment(null)}
            name="dataInserimento"
            label={t("creationdate")}
          >
            <RangePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col
          {...TwoColProps}
          xl={{ span: 3 }}
          md={{ span: 6 }}
          sm={{ span: 8 }}
        >
          <Row
            gutter={24}
            type="flex"
            align="middle"
            justify="space-between"
            style={{ border: "0px solid" }}
          >
            <div>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: "16px" }}
                onClick={handleSubmit}
              >
                {t("search")}
              </Button>
              <Button onClick={handleReset}>Reset</Button>
            </div>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default Filter;
